import {
  REALTIME_UPDATE_SERVICE_FAILED,
  REALTIME_UPDATE_SERVICE_LOADING,
  REALTIME_UPDATE_SERVICE_SUCCESS,
} from "../types"

const initialState = {
  loading: false,
  error: false,
  message: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case REALTIME_UPDATE_SERVICE_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        message: null,
      }
    case REALTIME_UPDATE_SERVICE_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      }
    case REALTIME_UPDATE_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: action.payload,
      }
    default:
      return state
  }
}
